var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"thumbs up\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.6774 31.3059H3.00262C2.44889 31.3059 2 30.857 2 30.3032V13.9271C2 13.3733 2.44889 12.9244 3.00262 12.9244H7.62742C8.80137 12.9244 9.88923 12.3085 10.4932 11.3019L15.0224 3.75314C15.9998 2.12433 18.3016 1.96949 19.4882 3.45277C20.0475 4.15192 20.2278 5.08118 19.9705 5.93877L18.262 11.6337C18.069 12.277 18.5508 12.9244 19.2224 12.9244H26.8675C29.0711 12.9244 30.6717 15.0199 30.0918 17.1458L26.9016 28.8431C26.5051 30.2972 25.1845 31.3059 23.6774 31.3059Z",
    stroke: "#232323",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.84863 31.3052V12.9238",
    stroke: "#232323",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs_up.766f5495e26c6c30fd1e003e2d3e93a7.svg";
export { ForwardRef as ReactComponent };